module.exports = __webpack_public_path__ + "img/secondary_5x1_z18.75b96620.svg";